import type { ReactNode } from 'react';

type DevelopersPageHeaderProps = {
  title: string;
  subtitle?: string;
  titleTestId: string;
  subtitleTestId?: string;
  action?: ReactNode;
};

export const DevelopersPageHeader = ({
  title,
  subtitle,
  titleTestId,
  subtitleTestId,
  action
}: DevelopersPageHeaderProps) => (
  <header className="flex w-full items-center gap-4">
    <div className="flex flex-1 flex-col gap-1">
      <h1 className="text-2xl font-medium" data-testid={titleTestId}>
        {title}
      </h1>
      {subtitle && (
        <p className="text-sm text-slate-600" data-testid={subtitleTestId}>
          {subtitle}
        </p>
      )}
    </div>
    {action}
  </header>
);
